import '@/styles/globals.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import settings from '../configs/settings.json'
import assistantConfig from '../configs/assistant.json'

window.catalog_config = (window as any).catalog_config || (settings as any)
window.ai_chat_config = (window as any).ai_chat_config || (assistantConfig as any)

const app = createApp(App)
const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(vuetify)

app.mount('#one-800-products-app')
